var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-button',{staticClass:"dropdown-actions__btn dropdown-actions__btn--complete",attrs:{"type":_vm.type,"disabled":_vm.disabled,"data-cy":_vm.commonCy.SINGLE_ORDER.BUTTON__ACCEPT},on:{"click":function($event){return _vm.$emit('actionClicked')}}},[_vm._v(" "+_vm._s(_vm.isPrimary ? 'Accept Order' : 'Accept')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }